import React from 'react';
import Reflux from 'reflux';
import { Row, Col, Grid, Table } from 'bootstrap';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import { ColumnWidthClassNames } from 'shared/flux/stores/cuesheet/CuesheetConstants';
import HighlightMixin from 'main/components/show/cuesheet/highlightCellMixin.js';
import GuestCuesheetStore from 'flux/stores/cuesheet.guest/GuestCuesheetStore';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import EventViewActions from 'flux/actions/EventViewActions';
import EventViewStore from 'flux/stores/EventViewStore';
import TeamViewActions from 'flux/actions/TeamViewActions';
import ReadOnlyStore from 'flux/stores/ReadOnlyStore';
import EventShowListStore from 'flux/stores/EventShowListStore';
import EventShowListActions from 'flux/actions/EventShowListActions';
import classNames from 'classnames';
import PageHeader from 'main/components/show/cuesheet.guest/cuesheetPageHeader';
import PageFooter from 'main/components/show/cuesheet.guest/cuesheetPageFooter';
import CuesheetRow from 'main/components/show/cuesheet.guest/cuesheetRow';

require('style/main.printable');

export default React.createClass({
  displayName: 'GuestCuesheet',

  mixins: [
    HighlightMixin,
    Reflux.connectFilter(EventShowListStore, 'shows', (st) => st.get('shows')),
    Reflux.connectFilter(ReadOnlyStore, 'readOnly', (st) => st.get('readOnly')),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(GuestCuesheetStore, 'cuesheet'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    type: React.PropTypes.string,
    displayPageHeader: React.PropTypes.bool,
    displayPageFooter: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      type: 'generic',
    };
  },

  getInitialState() {
    return {
      debugMessages: [],
    };
  },

  componentWillMount() {
    const { teamId, eventId, showId } = this.context.router.state.params;

    CuesheetActions.populateForGuest(teamId, eventId, showId);
    EventViewActions.populateForGuest(teamId, eventId);
    TeamViewActions.populateForGuest(teamId);
    EventShowListActions.populateForGuest(teamId, eventId);
  },

  render() {
    const { event, cuesheet, readOnly } = this.state;

    const team = cuesheet.get('team');
    const show = cuesheet.get('show');
    const rows = cuesheet.get('rows');
    const unauthorized = cuesheet.get('unauthorized');
    const disableGuestPass = cuesheet.getIn(['show', 'disableGuestPass']);
    const displayType = cuesheet.getIn(['show', 'displayType']);

    const tableClasses = classNames('printable-cuesheet-table-container', {
      'printable-cuesheet-global-element-manager':
        event && event.get('globalElementManager'),
    });

    if (unauthorized) return this._getDisabledGuestPassNode(tableClasses);

    if (!team || !event || !show || !rows) return null;

    if (disableGuestPass || readOnly) {
      return this._getDisabledGuestPassNode(tableClasses, readOnly);
    }

    const displayClass = displayType === 'show' ? 'guest-cue' : 'guest-grid';

    const gridClasses = classNames(this.props.classes, displayClass);

    const header = <PageHeader {...this.props} />;
    const footer = <PageFooter {...this.props} />;

    const tableHeader = this._getTableHeader();
    const tableBodyAndRows = this._getTableBodyAndRows();

    return (
      <Grid fluid className={gridClasses}>
        <div className={tableClasses}>
          <Row>
            <Col md={24}>
              {header}
              <Row>
                <Table className="printable-cuesheet-table" bordered>
                  {tableHeader}
                  {tableBodyAndRows}
                </Table>
              </Row>
              {footer}
            </Col>
          </Row>
        </div>
        {/*this._getDebugNode()*/}
      </Grid>
    );
  },

  _getDisabledGuestPassNode(tableClasses, readOnly) {
    let message =
      'To have guest pass enabled for this link please contact your event admin.';
    if (readOnly) {
      message =
        'This is a past event and the guest pass access has expired. ' +
        'Please reach out to your event admin for more information.';
    }

    return (
      <div className={tableClasses}>
        <div className="text-center">
          <h3>Guest pass is disabled for this url.</h3>
          <h5>{message}</h5>
        </div>
      </div>
    );
  },

  _getTableHeader() {
    const { cuesheet } = this.state;

    const show = cuesheet.get('show');
    const settings = cuesheet.get('settings');
    const guestColumns = cuesheet.get('guestColumns');

    const displayType = show.get('displayType');

    if (!guestColumns) return null;

    const cells = guestColumns.map((column, id) => {
      let classes = column.get('classes') || '';
      const columnTitle = column.get('title');

      if (displayType === DisplayTypes.show) {
        const itemWidth = settings.get('itemColumn')
          ? settings.get('itemColumn').get('width')
          : ColumnWidthClassNames.Normal;

        if (
          column.get('title') === 'Item' ||
          column.get('title') === 'Description'
        ) {
          classes += ` cs-printable-cell-width-${itemWidth}`;
          return (
            <th className={classes} ref={`column-${id}`}>
              {columnTitle}
            </th>
          );
        }
      }

      if (column.get('width')) {
        classes += ` cs-printable-cell-width-${column.get('width')}`;
      } else if (Array.isArray(classes)) {
        classes += ' cs-printable-cell-width-narrow';
      }

      return (
        <th className={classes} ref={`column-${id}`}>
          {columnTitle}
        </th>
      );
    });

    return (
      <thead>
        <tr>{cells}</tr>
      </thead>
    );
  },

  /**
   * Get table body and rows
   */
  _getTableBodyAndRows() {
    const { cuesheet, event } = this.state;

    const { type } = this.props;

    const tags = cuesheet.get('tags');
    const show = cuesheet.get('show');
    const rows = cuesheet.get('rows');
    const rowMap = cuesheet.get('rowMap');
    const guestColumns = cuesheet.get('guestColumns');
    const titleRowsEnabled = cuesheet.get('titleRowsEnabled');

    if (!rows) return null;

    const rowNodes = rows.map((row) => {
      const rowPath = row.get('path');
      const item = rowMap.getIn(rowPath);

      return (
        <CuesheetRow
          {...{
            columns: guestColumns,
            item,
            event,
            show,
            printableType: type,
            titleRowsEnabled,
            tags,
          }}
          gridType={show.get('displayType')}
        />
      );
    });

    return <tbody>{rowNodes}</tbody>;
  },
});
